<template>
  <el-form
    class="not-house-input-start-form"
    ref="form"
    label-width="10em"
    :model="fakeForm"
    :rules="fakeFormRules"
  >
    <div>
      <el-form-item required label="房源类型" prop="houseType">
        <el-select
          placeholder="请选择房源类型"
          v-model="fakeForm.houseType"
          @change="resetSearcher"
        >
          <el-option
            v-for="(option, i) in getOptions('houseType')"
            :key="i"
            v-bind="option"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="zoneIds" label="归属片区">
        <el-cascader
          v-model="fakeForm.zoneIds"
          placeholder="请选择归属片区"
          style="width:18em;"
          ref="cascader"
          :options="zoneOptions"
          @change="resetSearcher"
        ></el-cascader>
      </el-form-item>
      <el-form-item
        required
        label="房源小区"
        prop="blockName"
        @focusout.native="handleFocusout"
      >
        <el-autocomplete
          placeholder="请输入房源小区"
          style="width:100%;"
          v-model="fakeForm.blockName"
          :fetch-suggestions="fetchSuggestions"
          @select="selectHouse"
          @change.native="handleSearcherChange"
        />
      </el-form-item>
      <el-form-item required label="录入个数" prop="count">
        <el-input-number
          placeholder="请输入需要录入个数"
          v-model.number="fakeForm.count"
          :min="1"
          :max="100"
        />
      </el-form-item>

      <div>
        <field-collection
          v-if="fakeForm.houseType"
          ref="fcRef"
          :type="getOptionLabel('houseType', fakeForm.houseType)"
          :count="fakeForm.count"
        />
      </div>

      <el-form-item required label="其他图片说明" prop="pictures">
        <el-upload
          class="_image-uploader"
          :action="imageHost"
          list-type="picture-card"
          :auto-upload="false"
          :on-change="onUploadChange"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          type="textarea"
          placeholder="请输入备注信息"
          v-model="fakeForm.memo"
        />
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import debounce from 'lodash/debounce'
import FieldCollection from './field-collection'
import { fetchZoneOptions, searchBlock } from '../fetch'
import { typeOptions } from './data/options'

const maps = new Map([
  ['houseType', typeOptions],
  ['blockName', []],
])

export default {
  components: {
    FieldCollection,
  },

  data() {
    return {
      imageHost: 'https://www.baidu.com',

      fakeForm: {
        houseType: '',
        zoneIds: [],
        blockName: '',
        count: 1,
        name: '',
        pictures: [],
        memo: '',
      },

      fakeFormRules: {
        houseType: [{ required: true, message: '房源类型必需' }],
        zoneIds: [{ required: true, type: 'array', message: '归属片区必需' }],
        blockName: [{ required: true, message: '房源小区必需' }],
        count: [{ required: true, message: '请输入录入个数' }],
        name: [{ required: true, message: '收款人姓名必需' }],
        pictures: [
          {
            required: true,
            message: '请选择其他说明图片',
            type: 'array',
            trigger: 'blur',
          },
        ],
      },

      zoneOptions: [],

      maps,
    }
  },

  mounted() {
    this.fetchSuggestions = debounce(this.fetchSuggestions, 600)
    this.$emit('mounted', this, this.$refs.form)
    fetchZoneOptions.call(this).then(zoneOptions => {
      this.zoneOptions = zoneOptions
      maps.set('zone', zoneOptions)
    })
  },

  methods: {
    handleSearcherChange() {
      this.isFulfilled = false
    },

    // 当搜索框失焦时，重置搜索框
    handleFocusout() {
      // 如果搜索框内有关键字，但是搜索框没有绑定选项，则重置搜索条件
      setTimeout(() => {
        if (this.fakeForm.blockName !== '' && !this.isFulfilled) {
          this.resetSearcher()
        }
      }, 300)
    },

    // 重置搜索条件，搜索结果，选项的值，如果有的话
    resetSearcher() {
      if (this.fakeForm.blockName !== '') {
        this.fakeForm.blockName = ''
        maps.set('blockName', [])
      }
    },

    fetchSuggestions(kw, cb) {
      const ids = this.fakeForm.zoneIds
      const blockId = Array.isArray(ids) && ids.length === 2 ? ids[1] : ''
      const houseType = this.fakeForm.houseType
      if (!kw) {
        cb([])
        return
      } else if (!blockId) {
        this.$message.warning('请先选择归属片区。')
        cb([])
        return
      } else if (!houseType) {
        this.$message.warning('请先选择房源类型。')
        cb([])
        return
      }

      searchBlock(blockId, kw, houseType)
        .then(res => {
          const options = res.map(item => ({
            ...item,
            value: item.address,
          }))
          maps.set('blockName', options)
          cb(options)
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    selectHouse(item) {
      this.isFulfilled = true
      console.log(item)
    },

    /**
     * 获取选项的标签
     * @param {string} key - 选项列表的键
     * @param {any} value - 选项的值
     * @returns {string}
     */
    getOptionLabel(key, value) {
      if (!value) return ''
      const option = maps.get(key).find(opt => opt.value === value)
      if (!option) return ''
      return option.label
    },

    /**
     * 获取发送给流程接口的参数值
     * @param {string} key - 选项列表的键
     * @param {any} value - 选项的值
     * @returns {string}
     */
    getDropdown(key, value) {
      if (Array.isArray(value) && value.length === 2) {
        const p = maps.get(key).find(opt => opt.value === value[0])
        if (!p) return ''
        const l = p.children
        const opt = l.find(opt => opt.value === value[1])
        if (!opt) return ''
        return JSON.stringify({ name: opt.label, id: value[1] })
      }

      const name = maps.get(key).find(opt => opt.value === value).label
      return JSON.stringify({ name, id: value })
    },

    /**
     * 获取选项
     * @param {string} key - 选项列表的键
     * @param {any} value - 选项的值
     * @returns {{label: string; value: any}[]}
     */
    getOptions(key) {
      return maps.get(key)
    },

    noop() {},

    /**
     * 校验 field collection
     * @returns {boolean}
     */
    validateFC() {
      let ref = this.$refs.fcRef
      if (!ref) return false
      return ref.validate()
    },

    getOptionByValue(key, value) {
      return maps.get(key).find(opt => opt.value === value)
    },

    getForm() {
      const block = this.getOptionByValue('blockName', this.fakeForm.blockName)
      return {
        houseType: this.fakeForm.houseType,
        zone: this.getDropdown('zone', this.fakeForm.zoneIds),
        blockName: JSON.stringify(block),
        count: this.fakeForm.count,
        ...(this.$refs.fcRef ? this.$refs.fcRef.getForm() : {}),
        pictures: this.fakeForm.pictures,
        memo: this.fakeForm.memo,
        address: block.address,
        houseTypeName: this.getOptionLabel(
          'houseType',
          this.fakeForm.houseType
        ),
        zoneId: this.fakeForm.zoneIds[1],
      }
    },

    onUploadChange(file, fileList) {
      this.fakeForm.pictures = fileList
      this.$refs.form.validateField('pictures')
    },
  },
}
</script>

<style lang="scss">
.not-house-input-start-form {
  width: 800px;
  font-size: 14px;
  .el-select,
  .el-cascader {
    width: 18em;
  }

  .el-form-item {
    width: 100%;
  }

  ._section-title {
    padding-left: 120px;
    font-size: 16px;
    margin-bottom: 16px;
  }

  ._form-section {
    border-bottom: 1px solid #cccccc;
    padding-top: 0.8em;
  }
  ._image-uploader {
    text-align: left;
  }

  ._s-text {
    padding: 8px;
  }

  ._bill-list {
    background: #f0f0f0;
  }

  ._bill-item:not(:last-child) {
    border-bottom: 1px solid #cccccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/none/workflow/not-house-input/forms/start-form.vue